import * as actionTypes from '../constants/persist'
import {apiCall} from '../../service/apiCall'
import { USER,PASS } from '../../service/base_url'
import {get} from 'lodash'
import { setLoadingTable,setLoadingBeranda } from './general'
import { setPersist,resetPersist } from './persist'
import Cookie from 'universal-cookie'
const cookie=new Cookie()
const token=cookie.get('login_cookie_forum')
export const loginForum=(data)=>async dispatch=>{
        dispatch(setLoadingTable(true))
        let dataReq={
            url:`/Admin/auth`,
            method:'POST',
            data:{
                data:data,
                auth:{username:USER,password:PASS}
            }
        }
        let res=await dispatch(apiCall(dataReq))
        if(get(res,'status')===200){
            dispatch(setLoadingTable(false))
            cookie.set('login_cookie_forum',res.data.accessToken.token)
            cookie.set('refresh_cookie_forum',res.data.refreshToken)
            let profile={
                email:res.data.email,
                name:res.data.firstName,
                id:res.data.id,
                profilePic:res.data.profilePic
            }  
            cookie.set('profile_cookie_forum',profile)
            return res
            // window.location.reload() 
            // window.location.assign('/forum')
        }else{
            dispatch(setLoadingTable(false))
        }
}

export const forumAuth=(forumId,tokens=token)=>async dispatch=>{
    dispatch(setLoadingBeranda(true))
    let dataReq={
        url:`/Forum/auth/${forumId}`,
        method:'GET',
        data:{
            headers:{ 'Authorization': `Bearer ${tokens}`},
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingBeranda(false))
        dispatch(setPersist({forum_auth:res.data}))
        return res
        // window.location.reload() 
        // window.location.assign('/forum')
    }else{
        dispatch(setLoadingBeranda(false))
    }
}


export const logout=(query)=>dispatch=>{
    dispatch(resetPersist())
    cookie.remove('login_cookie_forum', { path: '/' })
    cookie.remove('refresh_cookie_forum', { path: '/' })
    cookie.remove('profile_cookie_forum', { path: '/' })
   
    window.location.assign(`/login?${query?query:''}`)
}

export const loginForum2=(data)=>async dispatch=>{
    dispatch(setLoadingTable(true))
    let dataReq={
        url:`/Admin/login`,
        method:'POST',
        isLogin:true,
        data:{
            data:data,
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===200){
        dispatch(setLoadingTable(false))
        cookie.set('login_cookie_forum',res.data.accessToken.token)
        cookie.set('refresh_cookie_forum',res.data.refreshToken)
        let profile={
            email:res.data.email,
            name:res.data.firstName,
            id:res.data.id,
            profilePic:res.data.profilePic
        }  
        cookie.set('profile_cookie_forum',profile)
        return res
        // window.location.reload() 
        // window.location.assign('/forum')
    }else{
        dispatch(setLoadingTable(false))
    }
}

export const registerForum=(data)=>async dispatch=>{
    dispatch(setLoadingTable(true))
    let dataReq={
        url:`/admin/register`,
        method:'POST',
        isLogin:true,
        data:{
            data:data,
            auth:{username:USER,password:PASS}
        }
    }
    let res=await dispatch(apiCall(dataReq))
    if(get(res,'status')===204){
        // dispatch(setLoadingTable(false))
        // cookie.set('login_cookie_forum',res.data.accessToken.token)
        // cookie.set('refresh_cookie_forum',res.data.refreshToken)
        // let profile={
        //     email:res.data.email,
        //     name:res.data.userName,
        //     id:res.data.id,
        //     profilePic:res.data.profilePic
        // }  
        // cookie.set('profile_cookie_forum',profile)
        return res
        // window.location.reload() 
        // window.location.assign('/forum')
    }else{
        dispatch(setLoadingTable(false))
    }
}